module.exports = __webpack_public_path__ + "img/advant3.02db3072.png";